var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.444447 0L0.750001 12.8386H3.16667L3.55556 0H0.444447ZM2 15.1457C0.888889 15.1457 0 16.0143 0 17.0729C0 18.1586 0.916667 19 1.97222 19C3.08333 19 4 18.1586 4 17.0729C4 16.0143 3.08333 15.1457 2 15.1457Z",
    fill: "#C81F1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclamation);
export default __webpack_public_path__ + "static/media/redExclamation.ee6c4efcf1fab445207ca608d6e24a0c.svg";
export { ForwardRef as ReactComponent };